import { displayLocalDateTime } from "utils";

export const Message = ({
  createdAt,
  creatorId,
  message,
  originatorId,
  originatorName,
  admins = [],
  marketers = [],
  schedulers = [],
}) => {
  const time = displayLocalDateTime(createdAt);

  const specialists = [...admins, ...marketers, ...schedulers];
  
  const isYourMessage = creatorId === originatorId;
  const teamMember = specialists.find(
    ({ userId }) => userId === creatorId && !isYourMessage
  );

  const getSpecialistRoleById = (id) => {
    if (admins.find(({ userId }) => userId === id)) return "Admin";
    if (marketers.find(({ userId }) => userId === id)) return "Marketer";
    if (schedulers.find(({ userId }) => userId === id)) return "Scheduler";
    return null;
  };

  const getMessageAuthorById = (id) => {
    if (id === originatorId) return `${originatorName}, Sender (You)`;

    return isYourMessage
      ? "You"
      : teamMember
      ? [teamMember?.name, getSpecialistRoleById(teamMember.userId)].join(", ")
      : "Team Member";
  };

  return (
    <div
      className={[
        "px-4 my-1 flex flex-col justify-start w-full gap-0.5 text-left",
        isYourMessage ?  "items-end" : "items-start",
      ].join(" ")}
    >
      <div className={"text-sm text-gray-900 px-1"}>
        {getMessageAuthorById(creatorId)}
      </div>
      <div
        className={[
          "p-2 rounded-lg shadow-md text-sm",
          teamMember && "bg-blue-600 text-white mr-6",
          isYourMessage && "bg-gray-300 ml-6 text-black",
          // isIncoming && "bg-cyan-300 mr-6",
        ].join(" ")}
        style={{ whiteSpace: "pre-line" }}
      >
        {message}
      </div>
      <div className={"text-xs px-1 text-gray-600"}>{time}</div>
    </div>
  );
};
